import { render, staticRenderFns } from "./team.vue?vue&type=template&id=0356cf9a&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=0356cf9a&prod&lang=less"
import style1 from "./team.vue?vue&type=style&index=1&id=0356cf9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356cf9a",
  null
  
)

export default component.exports